/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_NavInputs */

const en_svc_rag_nav = /** @type {(inputs: Svc_Rag_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG & AI knowledge bases`)
};

const lv_svc_rag_nav = /** @type {(inputs: Svc_Rag_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG un AI zināšanu bāzes`)
};

/**
* | output |
* | --- |
* | "RAG & AI knowledge bases" |
*
* @param {Svc_Rag_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_nav = /** @type {((inputs?: Svc_Rag_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_nav(inputs)
	return en_svc_rag_nav(inputs)
});